import React from 'react';

const TimerIcon = ({ size = 18, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <circle cx="12" cy="14" r="8" />
    <line x1="12" y1="14" x2="12" y2="10" />
    <line x1="12" y1="2" x2="12" y2="4" />
    <line x1="19.5" y1="6.5" x2="18.1" y2="7.9" />
  </svg>
);

export default TimerIcon; 